import { Theme } from './types';

export const darkTheme: Theme = {
  colors: {
    bg: {
      primary: 'rgba(0, 0, 0, 1)',
      secondary: 'rgba(18, 18, 18, 1)',
      tertiary: 'rgba(38, 38, 38, 1)',
      overlay: 'rgba(0, 0, 0, 0.8)'
    },
    fg: {
      primary: 'rgba(255, 255, 255, 1)',
      secondary: 'rgba(168, 168, 168, 1)',
      tertiary: 'rgba(115, 115, 115, 1)',
      inverse: 'rgba(0, 0, 0, 1)'
    },
    accent: {
      primary: 'rgba(200, 200, 200, 1)',
      secondary: 'rgba(160, 160, 160, 1)',
      success: 'rgba(88, 195, 34, 1)',
      error: 'rgba(237, 73, 86, 1)',
      warning: 'rgba(255, 164, 26, 1)'
    },
    newng: {
      red: 'rgba(220, 20, 60, 1)',      // Crimson red
      blue: 'rgba(0, 123, 255, 1)',     // Pure vibrant blue (Bootstrap blue)
      white: 'rgba(255, 255, 255, 1)',  // Pure white
      black: 'rgba(0, 0, 0, 1)'         // Pure black
    },
    border: {
      light: 'rgba(74, 74, 74, 1)',
      medium: 'rgba(90, 90, 90, 1)',
      heavy: 'rgba(110, 110, 110, 1)'
    },
    gradients: {
      primary: 'linear-gradient(45deg, rgba(200, 200, 200, 1), rgba(160, 160, 160, 1))',
      surface: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)',
      accent: 'linear-gradient(135deg, rgba(180, 180, 180, 1), rgba(140, 140, 140, 1), rgba(120, 120, 120, 1))'
    },
    overlay: {
      light: 'rgba(255, 255, 255, 0.1)',
      medium: 'rgba(255, 255, 255, 0.2)',
      heavy: 'rgba(255, 255, 255, 0.4)'
    }
  },
  buttons: {
    primary: {
      background: 'rgba(200, 200, 200, 1)',
      text: 'rgba(0, 0, 0, 1)',
      hover: 'rgba(220, 220, 220, 1)',
      active: 'rgba(180, 180, 180, 1)'
    },
    secondary: {
      background: 'rgba(0, 0, 0, 1)',
      text: 'rgba(255, 255, 255, 1)',
      hover: 'rgba(26, 26, 26, 1)',
      active: 'rgba(44, 44, 44, 1)'
    },
    error: {
      background: 'rgba(237, 73, 86, 1)',
      text: 'rgba(255, 255, 255, 1)',
      hover: 'rgba(220, 45, 60, 1)',
      active: 'rgba(201, 28, 45, 1)'
    },
    disabled: {
      opacity: 0.3
    },
    borderRadius: '8px',
    transition: 'all 0.2s ease-in-out'
  },
  effects: {
    frostedGlass: {
      background: 'rgba(0, 0, 0, 0.8)',
      blur: '10px',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    },
    gradient: {
      primary: 'linear-gradient(45deg, rgba(200, 200, 200, 1), rgba(160, 160, 160, 1))',
      dark: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)',
      evolved: 'linear-gradient(135deg, rgba(180, 180, 180, 1) 0%, rgba(140, 140, 140, 1) 50%, rgba(120, 120, 120, 1) 100%)'
    },
    shadow: {
      sm: '0 1px 3px rgba(0, 0, 0, 0.3)',
      md: '0 4px 6px rgba(0, 0, 0, 0.4)',
      lg: '0 10px 15px rgba(0, 0, 0, 0.5)'
    }
  }
};
